import { getterTree } from "typed-vuex";
import state from "./state";

/**
 * Ranking module getters.
 */
const getters = getterTree(state, {});

export default getters;
